import {
  Fastfood as FastfoodIcon,
  GridView as GridViewIcon,
} from '@mui/icons-material';
import { alpha, Box, Button, Menu, MenuProps, styled } from '@mui/material';

export const Wrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

export const PublicationWrapper = styled(Box)`
  display: flex;
  gap: 15px;
`;

interface StyledMenuProps extends MenuProps {
  boxPadding?: string;
}

export const StyledMenu = styled((props: StyledMenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))<StyledMenuProps>(({ theme, boxPadding }) => ({
  '& .MuiPaper-root': {
    borderRadius: 5,
    minWidth: 172,
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      paddingTop: '0',
      paddingBottom: '0',
      '.MuiButtonBase-root': {
        paddingLeft: '0',
        paddingRight: '0',
      },
    },
    '& .MuiMenuItem-root': {
      paddingTop: '0',
      paddingBottom: '0',
      '& .MuiBox-root': {
        paddingTop: boxPadding ?? '16px',
        paddingBottom: boxPadding ?? '16px',
        paddingLeft: boxPadding ?? '16px',
        paddingRight: boxPadding ?? '16px',
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

export const MenuWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const FastfoodIconStyled = styled(FastfoodIcon)(
  ({ theme }) => `
    width:20px;
    height:20px;

    & path {
      fill: ${theme.palette.brand.charcoal};
    }
`,
);

export const GridViewIconStyled = styled(GridViewIcon)(
  ({ theme }) => `
  width: 20px;
  height: 20px;
   path {
  fill: ${theme.palette.brand.charcoal};
}
`,
);

export const ScheduleComponentButton = styled(Button)(
  ({ theme }) => `
    width: 200px;
    height: auto;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    padding: 8px 22px;

    &.Mui-disabled {
      color: ${theme.palette.grey[500]};
      border: 1px solid ${theme.palette.grey[300]};
    }
`,
);
export const PreviewButton = styled(Button)`
  height: auto;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  padding: 8px 22px;
`;
